/** Synchronous copy via hidden textarea — must run in the same turn as the click handler. */
function execCommandCopy(text: string): boolean {
  if (typeof document === 'undefined' || !text) return false;

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('aria-hidden', 'true');
  textarea.style.position = 'fixed';
  textarea.style.top = '0';
  textarea.style.left = '0';
  textarea.style.width = '1px';
  textarea.style.height = '1px';
  textarea.style.padding = '0';
  textarea.style.border = 'none';
  textarea.style.outline = 'none';
  textarea.style.boxShadow = 'none';
  textarea.style.background = 'transparent';
  textarea.style.opacity = '0';
  textarea.style.pointerEvents = 'none';

  document.body.appendChild(textarea);
  textarea.focus();

  let ok = false;
  try {
    textarea.select();
    textarea.setSelectionRange(0, text.length);
    ok = document.execCommand('copy');
  } catch {
    ok = false;
  }

  document.body.removeChild(textarea);
  return ok;
}

/** Copy text synchronously — preferred inside click handlers (iframe + Safari safe). */
export function copyTextToClipboardSync(text: string): boolean {
  if (!text) return false;
  return execCommandCopy(text);
}

/**
 * Copy text to clipboard.
 * Tries sync execCommand first (preserves user gesture), then Clipboard API.
 */
export async function copyTextToClipboard(text: string): Promise<boolean> {
  if (!text) return false;
  if (copyTextToClipboardSync(text)) return true;

  try {
    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // Clipboard API blocked (iframe policy, permission, non-secure context)
  }

  return false;
}
